import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ClipboardService } from '../../../service/clipboard.service';

@Component({
  selector: 'app-copy-text',
  templateUrl: './copy-text.component.html',
  styleUrls: ['./copy-text.component.scss'],
  providers: [MessageService]
})
export class CopyTextComponent {
  @Input() text: string = '';
  @Input() label: string = '';

  constructor(private clipboardService: ClipboardService, private messageService: MessageService) {}

  copyToClipboard(text: string): void {
    this.clipboardService.copyToClipboard(text);
    this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Text has been to clipboard' });
  }
}
